import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'Menu',
    isTitle: true
  },
  {
    id: 3,
    label: 'Inicio',
    icon: 'ri-home-3-line',
    link: '/',
    accesoId: 'HOME'
  },
  {
    id: 2,
    label: 'Conciliación Comisiones',
    icon: 'ri-shield-user-line',
    accesoId: 'CONC_COMISION',
    subItems: [
      {
        id: 9,
        label: 'Planillas',
        link: '/conciliacion-comisiones/search',
      },
      {
        id: 10,
        label: 'Consultas',
        link: '/conciliacion-comisiones/reports',
      },
      {
        id: 11,
        label: 'Facturas',
        link: '/conciliacion-comisiones/facturas',
      },
      {
        id: 12,
        label: 'Informe SubAgentes',
        link: '/conciliacion-comisiones/informe-subagentes',
      },
      {
        id: 13,
        label: 'Control Pago SubAgentes',
        link: '/conciliacion-comisiones/control-pago-subagentes',
      },
    ]
  },
  {
    id: 4,
    label: 'Reportes',
    icon: 'ri-dashboard-2-line',
    link: '/reportes',
    accesoId: 'REPORT_2'
  }
];
